import { isPending } from '@reduxjs/toolkit';
import { useEffect, useState } from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';

import { useActions } from '../../../hooks/useActions';
import { useCard } from '../../../hooks/useCard';
import { useReview } from '../../../hooks/useReview';
import { useUser } from '../../../hooks/useUser';
import { ReviewService } from '../../../service/review.service';
import { IReviewsComments } from '../../../store/review/review.interface';
import { countElements } from '../../../utils/array/countElements';
import { updateCommentLikes } from '../../../utils/array/updateCommentLikes';

export const useReviewItem = (review: IReviewsComments) => {
  const {
    setCommentId,
    setFocusForm,
    setAuthVisible,
    setReviewId,
    setLikesReviewData,
    setLikePending,
  } = useActions();
  const {
    isAddedComment,
    isLikeComment,
    commentId,
    likesCommentData,
    commentLikeId,
  } = useReview();

  const queryClient = useQueryClient();
  const { loggedIn, likePending } = useUser();
  const [comments, setComments] = useState<any>([]);
  const [showComments, setShowComments] = useState<boolean>(false);
  const [showCommentForm, setShowCommentForm] = useState<boolean>(false);
  const [commentIds, setCommentIds] = useState(0);
  const countComments = comments ? countElements(comments) : 0; // Подсчет общее количество комментариев
  useQuery(
    ['get comments', isAddedComment, review.id, commentId],
    () => ReviewService.getComment(review.id),
    {
      onSuccess: ({ data }) => {
        setComments(data.comments.children);
      },
    }
  );
  const { mutateAsync } = useMutation(
    (likeOrDislike: boolean | null) =>
      ReviewService.setLikeOrDislike(review.id, likeOrDislike),
    {
      onSuccess: ({ data }) => {
        setLikesReviewData(data.likes_info);
        /*queryClient.invalidateQueries(['get review', review.id]);*/
      },
    }
  );

  const onSetLike = async () => {
    if (!loggedIn) {
      return setAuthVisible(true);
    }
    setReviewId(review.id);
    setCommentIds(review.id);
    if (review.is_like_by_me) {
      await mutateAsync(null);
    } else {
      await mutateAsync(true);
    }
  };
  const onSetDislike = async () => {
    if (!loggedIn) return setAuthVisible(true);
    setReviewId(review.id);
    if (review.is_like_by_me === false) {
      await mutateAsync(null);
    } else if (review.is_like_by_me || review.is_like_by_me === null) {
      await mutateAsync(false);
    }
  };

  const onShowComments = () => {
    /*    // Открыть/закрыть комментарии
    if (comment_id !== commentId) setCommentId(comment_id); // Немного оптимизируем*/
    if (review.id !== commentLikeId) setCommentId(review.id);
    setShowComments((show) => !show);
    if (!countComments) setShowCommentForm(true);
    if (showCommentForm) setShowCommentForm(false);
    setFocusForm(true);
  };
  const onShowCommentForm = () => {
    if (!loggedIn) return setAuthVisible(true);
    // Открыть/закрыть форму комментарий
    if (review.id !== commentLikeId) setCommentId(review.id);
    if (showComments) setShowComments((show) => !show);
    setShowCommentForm((show) => !show);
    setFocusForm(true);
  };

  useEffect(() => {
    // Обновляем количество лайков
    const likes = {
      dislikes_count: likesCommentData.dislikes_count,
      likes_count: likesCommentData.likes_count,
      is_like_by_me: likesCommentData.is_like_by_me,
    };
    const items = updateCommentLikes(comments, commentLikeId, likes);
    // Обновляем состояние списка комментариев
    setComments(items);
  }, [likesCommentData]);

  useEffect(() => {
    if (isAddedComment) {
      setShowComments((show) => true);
    }
  }, [isAddedComment]);

  return {
    item: {
      comments,
      countComments,
      showComments,
      showCommentForm,
    },
    actions: {
      onSetLike,
      onSetDislike,
      onShowComments,
      onShowCommentForm,
    },
  };
};
